{
  "sources": {
    "jTz6aBR-GJ4": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/jTz6aBR-GJ4.mp4",
      "type": "video/mp4"
    },
    "PZ6P1iqyphM": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/PZ6P1iqyphM.mp4",
      "type": "video/mp4"
    },
    "bgF41IjO8dE": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/bgF41IjO8dE.mp4",
      "type": "video/mp4"
    },
    "5pul4HVdIAA": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/5pul4HVdIAA.mp4",
      "type": "video/mp4"
    },
    "SWjDeK9W1UA": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/SWjDeK9W1UA.mp4",
      "type": "video/mp4"
    },
    "8JX72GmPMww": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/8JX72GmPMww.mp4",
      "type": "video/mp4"
    },
    "-7AayTChOYY": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/-7AayTChOYY.mp4",
      "type": "video/mp4"
    },
    "qrNZ7K396dc": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/qrNZ7K396dc.mp4",
      "type": "video/mp4"
    },
    "7BAXxbGA3vE": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/7BAXxbGA3vE.mp4",
      "type": "video/mp4"
    },
    "vq5tsmjWDsE": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/vq5tsmjWDsE.mp4",
      "type": "video/mp4"
    }
  },
  "adTagUrl": "https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=1280x720&cust_params=sample_ct%3Dskippablelinear&ciu_szs=300x250&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&description_url=https%3A%2F%2Fklopotenko-ott-beta.pages.dev&correlator="
}
